import styled from 'styled-components';

import { CorUtil } from '@utils';

export const ConteinerMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 40px;
  width: 40px;

  color: ${({ theme }) => theme.cores.primaria.padrao};
  background-color: ${({ theme }) => theme.cores.primaria.variantes[200]};
  border-radius: 50%;

  font-size: 20px;
  font-weight: 700;

  cursor: pointer;
`;

export const IconeMenu = styled.div`
  height: 32px;
  width: 32px;
`;

export const Menu = styled.div`
  max-width: 300px;

  border-radius: 8px;
  background-color: ${({ theme }) => theme.cores.neutro[0]};
  color: ${({ theme }) => theme.cores.texto};

  box-shadow: 0px 4px 8px 0px ${({ theme }) => CorUtil.rgba(theme.cores.neutro[800], 0.3)};

  overflow: hidden;
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 32px;
  width: 32px;

  color: ${({ theme }) => theme.cores.primaria.padrao};
  background-color: ${({ theme }) => theme.cores.primaria.variantes[200]};
  border-radius: 50%;

  font-size: 14px;
`;

export const Usuario = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  padding: 16px;

  border-bottom: ${({ theme }) => theme.cores.neutro[200]} 1px solid;
  color: ${({ theme }) => theme.cores.texto};

  font-size: 16px;
  font-weight: 700;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;

  padding: 16px;

  font-size: 14px;
  font-weight: 700;

  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.cores.primaria.variantes[100]};
  }

  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => theme.cores.neutro[200]} 1px solid;
  }
`;
